/**
 * SanityCheckSection Component
 *
 * Container for data maintenance tools: integrity checks and string cleanup.
 */

import { useSimplifiedUserData } from '@/providers/SimplifiedUserDataProvider';
import { DataIntegrityCheckCard } from './DataIntegrityCheckCard';
import { CleanUpStringsCard } from './CleanUpStringsCard';

export function SanityCheckSection() {
  const { selectedGame } = useSimplifiedUserData();

  if (!selectedGame) return null;

  return (
    <div className="space-y-6">
      <DataIntegrityCheckCard gameId={selectedGame.id} />
      <CleanUpStringsCard gameId={selectedGame.id} />
    </div>
  );
}

export default SanityCheckSection;
